"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const address_1 = __importDefault(require("../../address"));
const carrier_class_1 = __importDefault(require("../carrier.class"));
const errors_1 = __importStar(require("../../errors"));
class AirCarrier extends carrier_class_1.default {
    constructor(id, name, email, phone, ein, address, airlineName, flightNumber) {
        super(__1.eTransportMode.AIR, id, name, email, phone, ein, address);
        this.airlineName = airlineName;
        this.flightNumber = flightNumber;
    }
    update(carrier) {
        super.update(carrier);
        this.airlineName = carrier.airlineName;
        this.flightNumber = carrier.flightNumber;
    }
    static fromObj(data) {
        return new AirCarrier(data.id, data.name, data.email, data.phone, data.ein, data.address ? address_1.default.fromObj(data.address) : undefined, data.airlineName, data.flightNumber);
    }
    static empty() {
        return new AirCarrier("", "", "");
    }
    validate(path, isPrimary = true) {
        const errors = [];
        errors.push(...super.validate(path, isPrimary));
        if (isPrimary) {
            if (!this.airlineName) {
                errors.push(new errors_1.default(errors_1.eErrorCode.AIRLINE_NAME_NOT_SET, `${path}.airlineName`));
            }
            if (!this.flightNumber) {
                errors.push(new errors_1.default(errors_1.eErrorCode.FLIGHT_NUMBER_NOT_SET, `${path}.flightNumber`));
            }
        }
        return errors;
    }
}
exports.default = AirCarrier;
//# sourceMappingURL=airCarrier.class.js.map